/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from "react";
import Geosuggest from "react-geosuggest";

class GoogleAddressField extends Component {
  constructor(props) {
    super(props);

    this.input = React.createRef();
  }

  componentDidMount() {
    this.handlComponentMountUpdate();
  }

  componentDidUpdate() {
    this.handlComponentMountUpdate();
  }

  /**
   * @function handlComponentMountUpdate
   * @description gets called on mount and update
   */
  handlComponentMountUpdate = () => {
    const { label, valid, ...rest } = this.props;
  };

  handleSuggestSelect = e => {
    const { suggestSelect } = this.props;
    this.input.current.hideSuggests();
    if (e) {
      const { gmaps, label, location } = e;
      suggestSelect(gmaps, label, location);
    }
  };

  render() {
    const { label, valid, valueToShow, parentContainer, ...rest } = this.props;

    return (
      <Geosuggest
        ref={this.input}
        inputClassName={`form__input ${parentContainer}`}
        placeholder=""
        {...rest}
        onSuggestSelect={this.handleSuggestSelect}
        country={["in"]}
        parentContainer={parentContainer}
      />
    );
  }
}

export default GoogleAddressField;
